/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 申込者情報
 */
export interface Szoa206aResponseElecAceptSearchResultDtoSrnperInfo {
    /**
     * 申込者需要者区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C401051」のユーザコードを設定
     */
    srnperCnsdiv?: string;
    /**
     * 申込者需要者区分名称：全半角混在
     */
    srnperCnsdivAname?: string;
    /**
     * 申込者関係区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C401070」のユーザコードを設定
     */
    srnperRltdiv?: string;
    /**
     * 申込者関係区分名称：全半角混在
     */
    srnperRltdivAname?: string;
    /**
     * 申込者漢字氏名：全角
     */
    srnperName?: string;
    /**
     * 申込者カナ氏名：全角（カナ/数字/英字/スペース/記号）
     */
    srnperKanaName?: string;
    /**
     * 申込者電話番号コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C000010」のユーザコードを設定
     */
    srnperTeldv?: string;
    /**
     * 申込者電話番号コード名称：全半角混在
     */
    srnperTeldvAname?: string;
    /**
     * 申込者電話番号：半角
     */
    srnperTelNo?: string;
}

